@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  @include z-index(pluginMenu);
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.1s cubic-bezier(0.9, 0, 0.6, 1);
}
